import styled from "styled-components";
import { devices } from "../../globalStyle";
import { Link } from "react-router-dom";

export const StyledLink = styled(Link)`
  user-select: none;
`

export const HeaderContainer = styled.header`
  display: flex;
  background-color: #fff;
  justify-content: space-between;
  align-items: center;
  padding: 0.8rem 1.2rem;
  gap: 2rem;
  border-bottom: 1px solid #ebebeb;
  img{
    height: 1.5rem;
  }
`

export const LogoutWrapper = styled.div`
position: relative;
  display: inline-block;

  &:hover::after {
    content: 'Logout';
    position: absolute;
    bottom: -30px;
    left: 50%;
    transform: translateX(-50%);
    background: #1f1f1f;
    color:rgb(204, 204, 204);
    padding: 5px 8px;
    border-radius: 1px;
    font-size: 12px;
    white-space: nowrap;
    opacity: 0;
  }

  &:hover::after {
    opacity: 1;
  }
`;

export const SearchDiv = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: space-between;
  background-color: #f4f4f4;
  padding: .15rem .8rem;
  height: 2.4rem;
  flex: 1;
  max-width: 100rem;
  border-radius: 4rem;

  @media ${devices.largeDesktop} {

  }
`

export const SearchInput = styled.input`
  display: flex;
  border: 0;
  background-color: #f4f4f4;
  height: 100%;
  width: 100%;

  :focus {
    outline: none;
  }

  @media ${devices.largeDesktop} {
  }
`

export const SearchImg = styled.img`
  width: 1.1rem;
  cursor: pointer;

  @media ${devices.largeDesktop} {

  }
`

export const InfoDiv = styled.div`
  display: flex;
  align-items: center;
  user-select: none;
  gap: .7rem;
  font-size: 0.8rem;
  img{
    width: 1.7rem;
    height: 1.7rem;
    border-radius: 50%;
  }
`